import * as React from "react";

export interface IFillProps {
  fill?: string;
}
const SayAppIcon: React.SFC<IFillProps> = props => (
  <svg
    width="85"
    height="87"
    viewBox="0 0 85 87"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-149 -251)">
        <g id="Group-7" transform="translate(149 251)">
          <g id="Group" transform="translate(8 10)">
            <rect
              stroke="none"
              fill="#FAe8d1"
              x="0.5"
              y="0.5"
              width="76"
              height="76"
              rx="10"
            />
            <path
              d="M18,36.9802289 L28.6040697,23 L36.9359513,23 L28.6099827,35.8834954 L35.0473232,35.8834954 L35.0473232,54 L18,54 L18,36.9802289 Z M60,54 L42.9495232,54 L42.9495232,35.8834954 L49.3868636,35.8834954 L41.060895,23 L49.3931709,23 L60,36.9802289 L60,54 Z"
              id="Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
          <g id="Group-6">
            <rect
              fill={props.fill ? props.fill : "#1C9"}
              width="40.936"
              height="20.443"
              rx="1.2"
            />
            <path
              d="M10.4114225,10.0810247 C10.773743,10.1808682 11.047725,10.3719721 11.2333769,10.654342 C11.4190287,10.936712 11.5118532,11.2635386 11.5118532,11.6348317 C11.5118532,12.2806944 11.3127296,12.7744444 10.9144765,13.1160964 C10.5162234,13.4577485 9.95628191,13.6285719 9.23463527,13.6285719 L6.82267071,13.6285719 L6.82267071,6.81428596 L9.06844777,6.81428596 C9.80506633,6.81428596 10.3709965,6.96638904 10.7662552,7.27059975 C11.161514,7.57481047 11.3591404,8.03735982 11.3591404,8.65826169 C11.3591404,8.9765129 11.2775446,9.26043865 11.1143507,9.51004744 C10.9511567,9.75965623 10.7168497,9.94998008 10.4114225,10.0810247 Z M7.98598323,7.79243552 L7.98598323,9.67853253 L9.07743088,9.67853253 C9.43376262,9.67853253 9.70999044,9.59585086 9.90612261,9.43048503 C10.1022548,9.26511921 10.2003194,9.03267451 10.2003194,8.73314396 C10.2003194,8.40241231 10.1089921,8.16294746 9.92633461,8.01474224 C9.74367716,7.86653702 9.45771774,7.79243552 9.06844777,7.79243552 L7.98598323,7.79243552 Z M9.23463527,12.6551025 C9.5939614,12.6551025 9.87018921,12.5622806 10.063327,12.3766341 C10.2564648,12.1909875 10.3530322,11.9437225 10.3530322,11.6348317 C10.3530322,10.9234466 9.99670585,10.5677594 9.28404237,10.5677594 L7.98598323,10.5677594 L7.98598323,12.6551025 L9.23463527,12.6551025 Z M18.6534243,12.6551025 L18.6534243,13.6285719 L14.3639901,13.6285719 L14.3639901,6.81428596 L18.6264749,6.81428596 L18.6264749,7.79243552 L15.5273026,7.79243552 L15.5273026,9.6410914 L18.1997773,9.6410914 L18.1997773,10.5958403 L15.5273026,10.5958403 L15.5273026,12.6551025 L18.6534243,12.6551025 Z M26.1318619,7.79243552 L24.0971879,7.79243552 L24.0971879,13.6285719 L22.9383669,13.6285719 L22.9383669,7.79243552 L20.9261506,7.79243552 L20.9261506,6.81428596 L26.1318619,6.81428596 L26.1318619,7.79243552 Z M32.3751221,12.0654047 L29.8643433,12.0654047 L29.3433231,13.6285719 L28.1261119,13.6285719 L30.5919751,6.81428596 L31.6385072,6.81428596 L34.1133535,13.6285719 L32.8961424,13.6285719 L32.3751221,12.0654047 Z M32.0472386,11.0872551 L31.1174869,8.29321066 L30.1877352,11.0872551 L32.0472386,11.0872551 Z"
              id="BETA"
              fill="#000"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SayAppIcon;



// WEBPACK FOOTER //
// ./src/pages/Index/SayAppIcon.tsx